<div class="form-group has-feedback has-feedback-left search-input {{ themeValue }}"
     [ngClass]="containerClass">
    <div class="input-group">
        <div class="input-group-prepend">
            <span class="input-group-text">
                <span class="fas fa-search fa-lg" aria-hidden="true"></span>
            </span>
        </div>
        <input [placeholder]="placeholderText"
               type="search"
               [attr.aria-label]="placeholderText"
               class="form-control"
               [(ngModel)]="model"
               [name]="'tableSearchInput'"
               (ngModelChange)="onModelChange()">

        <div role="button" [attr.aria-label]="'Clear search' | translate" class="input-group-append" [ngClass]="{'btn-hide': !showClearBtn()}" (click)="onClearAction($event)">
            <span class="input-group-text">
                <span class="fas fa-times fa-lg" [ngClass]="{'v-none': !showClearBtn()}" aria-hidden="true"></span>
            </span>
        </div>
    </div>
</div>
